import React from 'react'
import { Translation } from 'react-i18next'
import { WatchField, Field } from '../../form'
import mobileView from '../../utils/mobile.utils'

const AddToInvoice = ({
  classes,
  control,
  hideButton = false,
  type,
  onChange,
  disabled,
  isEditAllowance = false,
  allowanceEdit
}) => (
  <Translation>
    {(t) => {
      return (
        <div
          className={!mobileView && !hideButton ? 'col-sm-11' : undefined}
          style={{ paddingLeft: '2px', opacity: disabled ? 0.7 : 1 }}
        >
          <WatchField control={control} fields="decisionSelect">
            {(watch) => (
              <>
                <div>
                  <Field
                    name="decisionSelect"
                    inputType="checkbox-for-strings"
                    className={classes.radioButton}
                    control={control}
                    label={t('decisionDialog.addToInvoice')}
                    onChange={onChange}
                    stringValue="add_to_invoice"
                    disabled={
                      disabled ||
                      (isEditAllowance &&
                        allowanceEdit[0].invoice_id &&
                        allowanceEdit[0].invoice_id !== null)
                    }
                  />
                </div>
                <div>
                  <p
                    style={{ marginLeft: '20px' }}
                    className={
                      watch.decisionSelect === 'add_to_invoice'
                        ? 'visible'
                        : 'invisible'
                    }
                  >
                    {type === 'expense' || type === 'newExpense'
                      ? t('decisionDialog.addToInvoiceDesc')
                      : t('decisionDialog.addToInvoiceDesc1')}
                  </p>
                </div>
                <Field
                  name="decisionSelect"
                  inputType="checkbox-for-strings"
                  className={classes.radioButton}
                  control={control}
                  label={t('decisionDialog.addToPayroll')}
                  onChange={onChange}
                  stringValue="add_to_payroll"
                  disabled={
                    disabled ||
                    (isEditAllowance &&
                      allowanceEdit[0].invoice_id &&
                      allowanceEdit[0].invoice_id !== null)
                  }
                />
                <div>
                  <p
                    style={{ marginLeft: '20px' }}
                    className={
                      watch.decisionSelect === 'add_to_payroll'
                        ? 'visible'
                        : 'invisible'
                    }
                  >
                    {type === 'expense' || type === 'newExpense'
                      ? t('decisionDialog.addToPayrollDesc')
                      : t('decisionDialog.addToPayrollDesc1')}
                  </p>
                </div>
              </>
            )}
          </WatchField>
        </div>
      )
    }}
  </Translation>
)

export default AddToInvoice
